"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _searchPage = _interopRequireDefault(require("./base/search-page.store"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _searchResults = require("../../utils/search-results.utils");
var _group = _interopRequireDefault(require("../../utils/group.utils"));
var _constants = require("../../constants");
var _filters = require("../../constants/filters.constants");
var _dec, _dec2, _class, _descriptor;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StepPageStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function (_SearchPageStore) {
  (0, _inherits2.default)(StepPageStore, _SearchPageStore);
  function StepPageStore(initialState, $env, flightInfo) {
    var _this;
    if (initialState === void 0) {
      initialState = {};
    }
    (0, _classCallCheck2.default)(this, StepPageStore);
    _this = _callSuper(this, StepPageStore, [initialState, $env, flightInfo]);
    _this.direction = _constants.OUTBOUND;
    (0, _initializerDefineProperty2.default)(_this, "outboundItinerary", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.updateInitialState(initialState);
    _this.cleanupAutoruns();
    _this.initializeAutoruns();
    return _this;
  }
  (0, _createClass2.default)(StepPageStore, [{
    key: "itineraryGroups",
    get: function get() {
      var groupPaths = this.direction === _constants.OUTBOUND ? _constants.DEFAULT_GROUP_KEYS_OUTBOUND_MPNR : _constants.DEFAULT_GROUP_KEYS_INBOUND_MPNR;
      return (0, _group.default)(this.sortedSearchResults, groupPaths, this.minGroupLength);
    }
  }, {
    key: "allSearchResults",
    get: function get() {
      var stepResults = this.direction === _constants.OUTBOUND ? this.searchResults.outboundItineraries : this.searchResults.inboundItineraries;
      return stepResults;
    }
  }, {
    key: "firstNearByAirportItineraryId",
    get: function get() {
      var itineraries = (0, _searchResults.getTopPickCombinedItineraries)(this.itineraryGroups);
      return (0, _searchResults.getFirstNearbyItineraryId)(itineraries);
    }
  }, {
    key: "setOutboundItinerary",
    value: function setOutboundItinerary(itinerary) {
      this.outboundItinerary = itinerary;
    }
  }, {
    key: "filterOutNearbyAirports",
    value: function filterOutNearbyAirports() {
      this.updateInitialState({});
      var requestAirportsFilterQuery = this.searchResults.searchRequest.requestAirportsFilterQuery;
      var filterQueries = (0, _split2.default)(requestAirportsFilterQuery, _filters.FILTER_SEPARATOR_MAP.LEG);
      var filterQuery = this.direction === _constants.OUTBOUND ? filterQueries[0] : filterQueries[1];
      this.filters.airport.update(filterQuery, true);
    }
  }]);
  return StepPageStore;
}(_searchPage.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "outboundItinerary", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itineraryGroups", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itineraryGroups"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allSearchResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSearchResults"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "firstNearByAirportItineraryId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstNearByAirportItineraryId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setOutboundItinerary", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setOutboundItinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterOutNearbyAirports", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "filterOutNearbyAirports"), _class.prototype)), _class));